import { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Swal from 'sweetalert2';
import { AddRateOfPointService } from "../../services/AddRateOfPointService";
import * as BullCache from "../../util/BullCache";
import MarketDropdown from '../components/MarketDropdown';
import ScriptDropdown from '../components/ScriptDropdown';

function AddRateOfPoint() {

    const [selectedMarket, setSelectedMarket] = useState('');  
    const [selectedScript, setSelectedScript] = useState('');  
    const [quantity, setQuantity] = useState('');

    var allScripts = BullCache.getFromCache('allScripts');
    var user = BullCache.getFromCache("user");

    const handleMarketChange = (market) => {
        setSelectedMarket(market);
    };
    const handleScriptReset = () => {
        setSelectedScript(null); 
      };
    const handleScriptChange = (script) => {
        setSelectedScript(script);
    };

    const handleAmountChange = (e) => {
        setQuantity(e.target.value);
    };
    const handleSubmit = () => {
        if (!selectedMarket || !selectedScript || !quantity) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please Select All Fields!",
            });
            return;
        }

        const selectedData = {
            adminId: user.adminId,
            segment: selectedMarket,
            symbol: selectedScript,
            quantity: quantity
        };
        AddRateOfPointService.addRateOfPoint(selectedData).then(res => {
            if (res.code === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Added Successfully!!.."
                });
                setSelectedMarket(''); 
                setSelectedScript('');  
                setQuantity('');        
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                });
            }
        });
    };   

    return (
        <Card className="mt-2">
            <Card.Body>
                <Row className='mt-3'>
                    <Col >
                    <b className='fss-05'>MARKET</b>
                        
                        <MarketDropdown
                            allScripts={allScripts}
                            onMarketChange={handleMarketChange}
                            selectedMarket={selectedMarket}
                            onScriptReset={handleScriptReset}  
                        />
                    </Col>

                    <Col >
                    <b className='fss-05'>SCRIPT NAME</b>
                        
                        <ScriptDropdown
                            allScripts={allScripts}
                            selectedMarket={selectedMarket}
                            onScriptChange={handleScriptChange}
                        />
                    </Col>

                    <Col >
                        <b className=' fss-05' >RATE OF POINT</b>
                        <Form.Control type='number' className='bg-light text-black' size="sm"
                            value={quantity}
                            onChange={handleAmountChange}
                        />
                    </Col>

                    <Col className="mt-4">
                        <Button variant="success" size="sm w-25" onClick={handleSubmit}>Submit</Button>
                    </Col>
                </Row>

            </Card.Body>
        </Card>



    );
}

export default AddRateOfPoint;